import axios from 'axios';
import { prepareUserSession, resumeUserSessionSync } from '@/rxdb/offlineSync';

function loadStoredUser() {
    try {
        const raw = localStorage.getItem('####');
        const user = raw ? JSON.parse(raw) : null;
        return user && typeof user === 'object' ? user : null;
    } catch (error) {
        return null;
    }
}

const auth = {
    namespaced: true,
    state: {
        status: '',
        token: localStorage.getItem('#') || '',       
        orgid: null,
        username: localStorage.getItem('###') || '',
        user: loadStoredUser(),
        baseurl: process.env.VUE_APP_API_URL,
        accesskey: 'DxaGiSPm/CKRlSaPQnKCv3rQvV5Rj7MoPdHcZ79UvQg='
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading';
        },
        auth_token(state, { token }) {
            state.status = 'success'
            localStorage.setItem("#", token);
            state.token = token
        },
        auth_success(state) {
            state.status = 'success'           
        },
        auth_username(state, username) {
            state.status = 'success'  
            localStorage.setItem('###',username) 
            state.username = username
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout(state) {
            state.status = ''
            state.token = null
            state.user = null
            localStorage.removeItem('#');
            localStorage.removeItem('###');
            localStorage.removeItem('####');
        },
        clear_external_session(state) {
            state.status = '';
            state.token = null;
            state.user = null;
            state.username = '';
        },
        SAVE_USER_INFO (state, payload) {
            localStorage.setItem('####', JSON.stringify(payload))
            state.user=payload
          },
    },
    getters: {
        _userAuthToken: state => state.token,
        _user: state => state.user,
        _username:state => state.username,
        authStatus: state => state.status
    },
    actions: {
        Auth({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                commit('auth_request')              
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalAuth/Auth`, payload)
                    .then(resp => resp.data)
                    .then(loginuser => {
                        if (loginuser.responseCode == '00') {
                            const token = loginuser.data.accessToken;
                            const userDetails=loginuser.data.data;                           
                            prepareUserSession(userDetails, state.user)
                                .then(() => {
                                    commit('SAVE_USER_INFO', userDetails);
                                    commit('auth_token', { token });
                                    commit('SchoolStaff/Clear_School_Staff_Info', null, { root: true });
                                    resumeUserSessionSync();
                                    resolve(loginuser);
                                })
                                .catch(error => {
                                    commit('auth_error');
                                    reject(error);
                                });
                            return;
                        }
                        resolve(loginuser)
                    })
                    .catch(err => {
                        commit('auth_error')
                        localStorage.removeItem('#')
                        reject(err)
                    })
            })
        },
        ChangeDefaultPassword({ commit }, payload) {
            return new Promise((resolve, reject) => {                   
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalAuth/ChangeDefaultPassword`, payload)
                    .then(resp => resp.data)
                    .then(loginuser => {                       
                        resolve(loginuser)
                    })
                    .catch(err => {  
                        commit('auth_error')                     
                        reject(err)
                    })
            })
        },
        RetrievePassword({ commit }, Username) {
            return new Promise((resolve, reject) => {                   
                axios.get(`${process.env.VUE_APP_ENV_API_URL}PortalAuth/RetrievePassword?Username=${Username}`)
                    .then(resp => resp.data)
                    .then(loginuser => {                       
                        resolve(loginuser)
                    })
                    .catch(err => {  
                        commit('auth_error')                     
                        reject(err)
                    })
            })
        },
        ValidateToken({ commit, rootState }, requestedToken) {
            return new Promise((resolve, reject) => {
                const token = requestedToken || rootState.auth.token;
                if (!token) {
                    reject(new Error('No authentication token is available.'));
                    return;
                }
                const headers = {
                    Authorization: `bearer ${token}`
                };
                commit('auth_request')
                axios.get(`${process.env.VUE_APP_ENV_API_URL}PortalAuth/ValidateToken`, { headers })
                    .then(resp => resp.data)
                    .then(loginuser => {
                        commit('auth_success')
                        resolve(loginuser)
                    })
                    .catch(err => {
                        commit('auth_error')
                        reject(err)
                    })
            })
        },
        AuthenticateUser({ commit }, accessToken) {
            return new Promise((resolve, reject) => {

                const headers = { Authorization: `bearer ${accessToken}` };
                commit('auth_request')
                axios.get(`${process.env.VUE_APP_ENV_API_URL}PortalAuth/ValidateToken`, { headers })
                    .then(resp => resp.data)
                    .then(loginuser => {
                        resolve(loginuser)
                    })
                    .catch(err => {
                        commit('auth_error')
                        localStorage.removeItem('#')
                        reject(err)
                    })
            })
        },       
        MutateUsername({ commit }, username) {
            commit('auth_username', username);
        },
        Logout({ commit }) {
            return new Promise((resolve) => {
                commit('logout')
                localStorage.removeItem('#')
                delete axios.defaults.headers.common['Authorization']               
                resolve()
            })
        }
    },
}

export default auth
